import { render, staticRenderFns } from "./ModelRuleGrid.vue?vue&type=template&id=a9f8ac1c&"
import script from "./ModelRuleGrid.js?vue&type=script&lang=js&"
export * from "./ModelRuleGrid.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports